import { $ } from '../utils/Utils';
import endPoint from '../utils/end-points';

require('es6-promise').polyfill();
const axios = require('axios');

const login = (() => {
  const config = {
    triggers: [...$('.js-login')],
  };

  const handleClick = ({ e }) => {
    e.preventDefault();

    const loginInput = document.getElementById('login')
    const passwordInput = document.getElementById('password')
    const errorText = document.getElementById('show-error-text');

    if (loginInput && passwordInput !== '') {
      axios.post(`${endPoint.login}`, {
        login: loginInput.value,
        password: passwordInput.value
      }).then(response => {
        if (response.status === 200) {
          window.location.href = "/"
        }
      }).catch(error => {
        console.log(error);
        errorText.style.display = 'block';
      });
    } else {
      errorText.style.display = 'block';
    }
  };

  const build = () => {
    config.triggers.forEach(trigger => {
      trigger.addEventListener('click', e => handleClick({ e, trigger }));
    });
  };
  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };
  return {
    init,
  };
})();
export default login.init();
